import "./AllNotificationGroup.scss";
import CircularButton, { CustomButton, CustomLoadingButton } from "../../../components/ui/CustomButton.jsx";
import newRequest from "../../../utils/newRequest.js";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Popover
} from "@mui/material";
import { showToast } from "../../../toastService.js";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GridLoader } from "react-spinners";
import { SlArrowDown } from "react-icons/sl";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { FiSearch } from "react-icons/fi";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { useTranslation } from "react-i18next";
import { MdAdd, MdArrowBackIos, MdClose, MdDelete, MdEdit } from "react-icons/md";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import { IoDocumentTextSharp } from "react-icons/io5";
import { fetchSystemCodes, fetchUsersBySearch, logData } from "../../../utils/genericFunctions.js";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { useRef } from "react";
import { CiImageOn } from "react-icons/ci";


const AllNotificationGroup = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isGroupDialogOpen, setIsGroupDialogOpen] = useState(false);
  const [groupAction, setGroupAction] = useState(null);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const location = useLocation();
  const showBack = location.state?.showBack || "N";
  const favMenu = location.state?.favMenu || "N";
  const menuDocid = location.state?.menuDocid || undefined;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [detailsPerPage, setDetailsPerPage] = useState(5);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [groupsPage, setGroupsPage] = useState(0);
  const [notesGroups, setNotesGroups] = useState([]);
  const [sysType, setSysType] = useState(null);
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
    param1: "",
    param2: "",
  });
  const newCodeRef = useRef(null);
  const [grpCode, setGrpCode] = useState("");
  const [grpName, setGrpName] = useState("");
  const [grpStatus, setGrpStatus] = useState({
    value: "New",
    label: "New"
  });
  const [applicableGroupStatuses, setApplicableGroupStatuses] = useState("");

  const [searchTermGroup, setSearchTermGroup] = useState("");
  const [usersPage, setUsersPage] = useState(0);
  const [qualificationsPage, setQualificationsPage] = useState(0);
  const [rowsPerPageUsers, setRowsPerPageUsers] = useState(5);

  const [selectedUser, setSelectedUser] = useState(null);
  const [groupUsers, setGroupUsers] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const popoverOpen = Boolean(anchorEl);
  const id = popoverOpen ? 'simple-popover' : undefined;


  const fetchNotesGroups = async () => {
    try {
      const res = await newRequest.get("/ngroup/findAll");
      if (res.data) {
        const sortedGroups = res.data?.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        setNotesGroups(sortedGroups);
      } else {
        setNotesGroups([]);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  const definedStatuses = async () => {
    try {
      const options = ["New", "Active", "Under Review", "Closed"]?.map((val) => ({
        value: val,
        label: val,
      }));
      setApplicableGroupStatuses(options);
    } catch (error) {
      console.error("Error fetching defined sectors :", error);
    }
  };

  const handleGroupChangePage = (event, newPage) => {
    setGroupsPage(newPage);
  };

  const handleJobChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setGroupsPage(0);
  };

  const filteredGroupsData = notesGroups?.filter(
    (item) =>
      item.grp_name?.toLowerCase().includes(searchTermGroup?.toLowerCase())
  );

  const slicedGroupsData = filteredGroupsData?.slice(
    groupsPage * rowsPerPage,
    groupsPage * rowsPerPage + rowsPerPage
  );


  const handleAccodionChange = (panel, grp) => (event, isExpanded) => {
    try {
      setExpanded(isExpanded ? panel : false);
      setSelectedGroup(grp);
      setGroupUsers(grp?.grp_users);
    } catch (error) {
      console.log(error)
    }
  };


  const handleUsersChangePage = (event, newPage) => {
    setUsersPage(newPage);
  };

  const handleUsersChangeRowsPerPage = (event) => {
    setRowsPerPageUsers(parseInt(event.target.value, 5));
    setUsersPage(0);
  };

  const filteredUsersData = groupUsers;
  const slicedUsersData = filteredUsersData.slice(
    usersPage * detailsPerPage,
    usersPage * detailsPerPage + detailsPerPage
  );



  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteGroup") {
        await newRequest.post("/ngroup/del", {
          grp_docid: selectedGroup._id,
          branch_code: objectToAction.object_id
        });
        fetchNotesGroups();
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setIsConfirmDialogOpen(false);
  };

  const handleGroupAction = async () => {
    try {
      if (!grpCode) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter code!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!grpName) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter title!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (groupAction === "addGroup") {
        const res = await newRequest.post(
          "/ngroup/add",
          {
            grp_code: grpCode,
            grp_name: grpName,
            grp_users: []
          }
        );
        if (res.data?.msg === "added") {
          setNotesGroups((prevData) => {
            const updated = [...prevData, res.data?.doc];
            return updated.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
          });
          setIsGroupDialogOpen(false);
          showToast(`${grpName} added!`, "success");
          resetAction();
        } else if (res.data?.msg === "exists") {
          showToast(t('grpCodeExists', { param1: grpCode }), "error");
        } else {
          showToast(res.data?.msg, "error");
        }
      } else if (groupAction === "editGroup") {
        const res = await newRequest.put(
          `/ngroup/upd/${selectedGroup._id}`,
          {
            grp_name: grpName,
            grp_status: grpStatus?.value || "New",
          }
        );
        if (res.data?.msg === "updated") {
          const updatedGrp = res.data?.doc;
          setNotesGroups((prevJobs) => { return prevJobs.map((grp) => grp?._id === updatedGrp?._id ? updatedGrp : grp); });
          setIsGroupDialogOpen(false);
          showToast(`${grpName} updated!`, "success");
          resetAction();
        } else {
          showToast("Error updating group!", "error");
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const resetAction = () => {
    setGroupAction(null);
    setGrpCode("");
    setGrpName("");
    setGrpStatus(null);
  };


  useEffect(() => {
    fetchNotesGroups();
    definedStatuses();
  }, []);



  return (
    <motion.div
      className="ngroup"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <div className="ngroup-navbar">
        <div className="ngroup-navbar-left">
          <div className="search-input-wrapper" style={{ width: "90%" }}>
            <FiSearch className="search-input-icon" />
            <input
              className="search-input"
              type="text"
              placeholder={`${t('search')} ${t('group')}`}
              value={searchTermGroup}
              onChange={(e) => setSearchTermGroup(e.target.value)}
            />
            {searchTermGroup?.length > 0 && (
              <MdClose
                onClick={() => setSearchTermGroup("")}
                className="search-input-icon"
              />
            )}
          </div>
        </div>
        <div className="ngroup-navbar-right">
          <CustomLoadingButton
            currentTheme={currentTheme}
            borderRadiusType="both"
            variant="tint"
            color="#0ea5a4"
            tooltip={"Add new notification group"}
            iconPosition="end"
            endIcon={<MdAdd />}
            onClick={() => {
              try {
                resetAction();
                setGroupAction("addGroup");
                setIsGroupDialogOpen(true);
              } catch (error) {
                console.log(error);
              }
            }}
          >
            {t('add')}
          </CustomLoadingButton>
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            borderRadiusType="both"
            variant="tint"
            color="#2563EB"
            tooltip="Run notification group reports"
            endIcon={<IoDocumentTextSharp />}
            onClick={() => setReportsDialogOpen(true)}>
            {t('reports')}
          </CustomLoadingButton>
          {/* This part shows if the menu was opened from home screen */}
          {showBack === "Y" && <hr className="separator-v" />}
          {showBack === "Y" &&
            <span className="back-icon" onClick={() => navigate(-1)}>
              <MdArrowBackIos size={24} />
            </span>}
        </div>
      </div>
      {slicedGroupsData?.length > 0 &&
        <div className="ngroup-table-content">
          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
            className="table-container">
            <Table sx={{ width: "max-content", border: 'none' }}>
              <TableBody className="tablebody-accordion">
                {slicedGroupsData?.map((grp, index) => (
                  <TableRow
                    key={grp?._id}
                    className="tablerow-accordion">
                    <TableCell className="table-cell-accordion"
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center"
                      }}>
                      <Accordion className="accordion" expanded={expanded === grp?._id} onChange={handleAccodionChange(grp?._id, grp)}>
                        <AccordionSummary
                          className="accordion-summary"
                          expandIcon={<SlArrowDown className="content-accordion-expand-icon" style={{ color: "#f44336", fontWeight: "bold" }} />}
                          id={`panel-${grp?._id}-header`}
                        >
                          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%", marginRight: "50px" }}>
                            <Typography>
                              <h1 className="main-title">{groupsPage * rowsPerPage + index + 1}. {grp?.grp_name}</h1>
                            </Typography>
                            <Typography>
                              <div className="ngroup-details-wrapper">
                                <div className={`ngroup-details status ${grp?.grp_status}`}>
                                  <h1 className="account-no">{`CODE: ${grp?.grp_code}`}</h1>
                                  <h1 className="account-no">{`STATUS: ${grp?.grp_status}`}</h1>
                                </div>
                                <CircularButton
                                  currentTheme={currentTheme}
                                  onClick={async (e) => {
                                    try {
                                      setGrpCode(grp?.grp_code);
                                      setGrpName(grp?.grp_name);
                                      setGrpStatus({
                                        value: grp?.grp_status,
                                        label: grp?.grp_status
                                      });
                                      setGroupAction("editGroup");
                                      setIsGroupDialogOpen(true);
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  icon={<MdEdit color="purple" />} width={"30px"} height={"30px"} />
                              </div>
                            </Typography>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails className="accordion-details">
                          <div className="accordion-table">
                            <div style={{ display: "flex", flexDirection: "row", gap: "3px", alignItems: "center", paddingLeft: "5px" }}>
                              <span className="normal-title">{t('users')}</span>
                              <CircularButton
                                currentTheme={currentTheme}
                                aria-describedby={id}
                                onClick={(e) => {
                                  try {
                                    setSelectedUser(null);
                                    setAnchorEl(e.currentTarget);
                                    if (newCodeRef.current) {
                                      newCodeRef.current.focus();
                                    }
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                icon={<MdAdd color="green" />} width={"30px"} height={"30px"} />
                            </div>
                            <div className="table-content">
                              <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                <Table sx={{ width: "max-content", border: 'none' }}>
                                  <TableBody className="tablebody">
                                    {slicedUsersData?.map((row, index) => (
                                      <TableRow
                                        key={row?._id}
                                        className={`${selectedGroup?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                        onClick={() => setSelectedGroup(row)}
                                      >
                                        <TableCell className="table-cell center" style={{ maxWidth: "40px" }}>
                                          {usersPage * rowsPerPage + index + 1}
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                          <div className="avatar-container">
                                            <div className="left">
                                              {row?.usr_photo_url ? <img
                                                src={row?.usr_photo_url}
                                                alt=""
                                                className="avatar"
                                              /> : <CiImageOn className="avatar" />}
                                            </div>
                                            <div className="right">
                                              <span className="username">{row?.usr_full_name}</span>
                                              <span className="time-ago" style={{ fontSize: "10px" }}>{row?.usr_email}</span>
                                            </div>
                                          </div>
                                        </TableCell>
                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                          <CircularButton
                                            currentTheme={currentTheme}
                                            onClick={async (e) => {
                                              try {
                                                const res = await newRequest.post(`/ngroup/removeGroupUser/${grp?._id}`, { user_docid: row?.user_docid });
                                                if (res.data?.msg === "removed") {
                                                  setGroupUsers((prevData) => prevData.filter(doc => doc?.user_docid !== row?.user_docid));
                                                  showToast(t('removed'), "success");
                                                } else {
                                                  showToast("Error removing user!", "error");
                                                }
                                              } catch (error) {
                                                console.log(error);
                                              }
                                            }}
                                            color="#E53935" icon={<MdDelete/>} width={"30px"} height={"30px"} />
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                                {groupUsers?.length > rowsPerPageUsers &&
                                  <TablePagination
                                    rowsPerPageOptions={[5]}
                                    rowsPerPage={rowsPerPageUsers}
                                    onRowsPerPageChange={handleUsersChangeRowsPerPage}
                                    component="div"
                                    count={groupUsers?.length}
                                    page={usersPage}
                                    onPageChange={handleUsersChangePage}
                                  />}
                              </TableContainer>
                            </div>

                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            {filteredGroupsData.length > rowsPerPage &&
              <TablePagination
                rowsPerPageOptions={[10]}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleJobChangeRowsPerPage}
                component="div"
                count={filteredGroupsData.length}
                page={groupsPage}
                onPageChange={handleGroupChangePage}
              />}
          </TableContainer>
        </div>
      }
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader
              color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={["hr-jobs"]}
                documentData={{
                  docNo: "1",
                  docType: "HR Jobs",
                  docId: "1"
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {isGroupDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title" style={{ textTransform: "uppercase" }}>{groupAction === "addGroup" ? t('addGroup') : t('editGroup')}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    resetAction();
                    setIsGroupDialogOpen(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                <div className="input-item-with-label">
                  <label htmlFor="grp_code" style={{ width: "100px" }}>
                    {t('code').toUpperCase()}
                  </label>
                  <input
                    name="grp_code"
                    type="text"
                    placeholder={t('code').toUpperCase()}
                    className="form-input-item"
                    style={{ width: "130px" }}
                    value={grpCode}
                    onChange={(e) => setGrpCode(e.target.value)}
                    disabled={groupAction === "editGroup"}
                  />
                </div>
                <div className="input-item-with-label" style={{ alignSelf: "flex-end" }}>
                  <Select
                    id="grp_status"
                    name="grp_status"
                    menuPortalTarget={document.body}
                    styles={{
                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999,
                      })
                    }}
                    width="130px"
                    value={grpStatus}
                    onChange={(selectedOption) => setGrpStatus(selectedOption)}
                    options={applicableGroupStatuses}
                    isSearchable={true}
                    placeholder={t('status')}
                  />
                </div>
              </div>
              <div className="input-item-with-label">
                <label htmlFor="grp_name" style={{ width: "100px" }}>
                  {t('name').toUpperCase()}
                </label>
                <input
                  name="grp_name"
                  type="text"
                  placeholder={t('name').toUpperCase()}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  value={grpName}
                  onChange={(e) => setGrpName(e.target.value)}
                />
              </div>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                iconPosition="end"
                currentTheme={currentTheme}
                borderRadiusType="right"
                onClick={handleGroupAction}>
                {groupAction === "addGroup" ? t('add').toUpperCase() : t('update').toUpperCase()}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      <Popover
        id={id}
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{ padding: "20px" }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "max-content",
            marginBottom: "5px"
          }}>
            <span className="main-title">{t('add').toUpperCase()}</span>
            <CircularButton currentTheme={currentTheme}
              onClick={() => {
                try {
                  setAnchorEl(null);
                  setSelectedUser(null);
                } catch (error) {
                  console.log(error);
                }
              }} icon={<MdClose />} width={"35px"} height={"35px"} />
          </div>
          <div className="input-item-with-label" style={{ gap: "5px" }}>
            <AsyncSelect
              ref={newCodeRef}
              id="selectedUser"
              name="selectedUser"
              menuPortalTarget={document.body}
              styles={{
                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                menuPortal: base => ({
                  ...base,
                  zIndex: 9999,
                })
              }}
              width="450px"
              value={selectedUser}
              onChange={(selectedOption) => setSelectedUser(selectedOption)}
              loadOptions={(inputValue, callback) => fetchUsersBySearch(inputValue, callback, [])}
              isSearchable={true}
              placeholder={t('users').toUpperCase()}
              noOptionsMessage={() => "Type Minimum 2 Letter to Search"} />
            <CustomLoadingButton
              currentTheme={currentTheme}
              iconPosition="end"
              borderRadiusType="both"
              variant="tint"
              color="#0ea5a4"
              tooltip={"Save new group"}
              endIcon={<MdAdd />}
              onClick={async () => {
                try {

                  if (!selectedUser) {
                    setNotifyDialogTitle("Note!");
                    setNotifyDialogText(t('selectUser'));
                    setIsNotifyDialogOpen(true);
                    return;
                  }

                  // logData("selectedUser", selectedUser);

                  const res = await newRequest.post(`ngroup/addGroupUser/${selectedGroup?._id}`, { user_docid: selectedUser?.value });

                  if (res.data?.msg === "exists") {
                    showToast(t('userInGroup', { param1: selectedUser?.usr_full_name, param2: selectedGroup?.grp_name }), "error");
                    if (newCodeRef.current) {
                      newCodeRef.current.focus();
                    }
                    setSelectedUser(null);
                  } else if (res.data?.msg === "added") {
                    setGroupUsers((prevData) => {
                      const updated = [...prevData, res.data?.doc];
                      return updated.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
                    });
                    showToast(`${selectedUser?.usr_full_name} added!`, "success");
                    if (newCodeRef.current) {
                      newCodeRef.current.focus();
                    }
                    setSelectedUser(null);
                  } else {
                    showToast(res.data?.msg, "error");
                  }

                } catch (error) {
                  console.log(error);
                }
              }}>
              {t('add')}
            </CustomLoadingButton>
          </div>
        </div>
      </Popover>
    </motion.div>
  );
};

export default AllNotificationGroup;
